export enum UtmSource {
  Email = 'email',
  Google = 'google',
}

export enum UtmMedium {
  MagicLink = 'magic_link',
  OAuth = 'oAuth',
}
